<template>
  <div>
    <vue-good-table
        :columns="columns"
        :rows="onBoardingCompletedRequests"
        class="table-word-wrap"
        :pagination-options="{enabled: this.paginationEnabled, ...paginationOptions}"
    >
      <template slot="table-column" slot-scope="props">
                <span v-if="props.column.label === 'Supplier setup status'">
                  <header-with-tooltip :tooltipText="onBoardingStatusTooltip"> {{props.column.label}} </header-with-tooltip>
                </span>
        <span v-else>{{props.column.label}}</span>
      </template>
      <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'caseNumber'">
                              <span class="solution-link" @click="$emit('onViewCaseDetails', props.row.caseNumber)"> {{ props.row.caseNumber }} </span>
                            </span>
                            <span v-else-if="props.column.field === 'supplierOnBoardingStatus'">
                              <span v-if="isStatusFetched">
                                {{getOnBoardingStatusFor(props.row.caseNumber)}}
                                <div class="word-wrap" v-if="getVendorIdFor(props.row.caseNumber)">
                                  Supplier ID: {{getVendorIdFor(props.row.caseNumber)}}
                                </div>
                              </span>
                              <span v-else>Loading ...</span>
                            </span>
                            <span v-else-if="props.column.field === 'actions'">
                                <div class="content row-content">
                                  <span class="solution-link" @click="$emit('onViewCaseDetails', props.row.caseNumber)">  View </span> |
                                  <span class="solution-link" @click="duplicateCaseRedirect(props.row.id)"> Duplicate </span>
                                </div>
                            </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import VGT_COLUMNS from "@/store/vgtColumns";
import VGT_PAGINATION_OPTIONS from "../store/vgtPaginationOptions";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import SupplierOnboardStatusTrackerMixin from "@/mixins/SupplierOnboardStatusTrackerMixin";

export default {
  name: "CompletedRITMList",
  components: {VueGoodTable, HeaderWithTooltip},
  mixins: [SupplierOnboardStatusTrackerMixin],
  data() {
    return {
      paginationOptions: VGT_PAGINATION_OPTIONS.COMPLETED_CASE_PAGINATION_CONFIG,
      columns: VGT_COLUMNS.COMPLETED_CASE_COLUMNS
    }
  },
  computed: {
    paginationEnabled() {
      return this.onBoardingCompletedRequests.length > 5
    }
  },
  mounted() {
    this.fetchSupplierOnBoardingStatus()
  },
  methods: {
     duplicateCaseRedirect(id){
      this.$hhMixpanel.trackEvent("Duplicate case request")
      this.$router.push({name: "DuplicateIntakeForm", params: { id, isCompletedCase: true}})
    },
  }
}


</script>
<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>